import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {TableColumn, SortDirection, FieldType, TableBody} from '../../../index';


@Component({
  template: require('./table-cell-edit-number.html'),
  name: 'table-cell-edit-number'
})
export class TableCellEditNumber extends Vue {
  @Prop()
  row: any;

  @Prop()
  column: TableColumn;

  @Prop()
  edit: boolean;

  @Prop()
  tableData: Array<any>;

  @Prop()
  rowIndex: number;

  value: any;
  editing: boolean = false;

  created() {
    this.updateValue();
  }

  @Watch('row')
  @Watch('column')
  updateValue() {
    this.value = this.row[this.column.field];
  }

  editStart() {
    this.editing = true;
  }

  editComplete() {
    if (!this.editing) return;

    let oldValue = this.row[this.column.field];
    let newValue = this.value;
    let allowNull:boolean;
    if (typeof this.column.allowNull === 'function') {
      allowNull = this.column.allowNull(newValue, this.row, this.column);
    } else {
      allowNull = this.column.allowNull!;
    }

    // Check for non-numeric values and reset value
    let value = parseFloat(newValue);
    if(allowNull && this.value === '') newValue = null;
    else if (!isNaN(value)) newValue = value;
    else newValue = oldValue;


    if (oldValue !== newValue) {
      this.row[this.column.field] = newValue;
      this.$emit('dataEdit', this.row, this.column);
    }

    this.stopEdit();
  }

  stopEdit(cancel: boolean = false) {
    this.editing = false;
    if (cancel === true) {
      let oldValue = this.row[this.column.field];
      if (this.value !== oldValue) this.value = oldValue;
    }

    this.$emit('cellEditEnd', this.row, this.column);
  }

  validateKey(e: KeyboardEvent) {
    if (this.column.fieldType === FieldType.Number && (e.keyCode === 110 || e.keyCode === 190 )) {
      e.preventDefault();
    }

    return true;
  }
}


// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/table/editors/table-cell-edit-number.ts